import React, { Component } from 'react';
import { connect } from 'react-redux';
import ExcelBulkEditProductDiscountSuccessModal from '../../../../views/product/common/modal/ExcelBulkEditProductDiscountSuccessModal';
import withModal from '../../../../lib/hoc/withModal';
import { productActions } from '../../../../store/modules/product';
import { appActions } from '../../../../store/modules/app';

class ExcelBulkEditProductDiscountSuccessModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({
      name: 'excelBulkEditProductDiscountSuccessModal',
      value: false,
    });
  };

  render() {
    const { isOpen, data, getProductSubCategoryList } = this.props;

    return (
      <ExcelBulkEditProductDiscountSuccessModal
        isOpen={isOpen}
        data={data}
        getProductSubCategoryList={getProductSubCategoryList}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.product.excelBulkEditProductDiscountSuccessModal.isOpen,
    data: state.product.excelBulkEditProductDiscountSuccessModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: productActions.toggleModal,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withModal()(ExcelBulkEditProductDiscountSuccessModalContainer));
